<div class="row">
  <div class="col-md-12">
    <table class="table table-light mb-0" style="font-size: 85%">
      <thead>
      <span>Engine Contour</span>
      <tr>
        <th scope="col" style="width: 10%">{{ 'pages.decision.model.batch' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.total' | translate }}</th>
        <th scope="col" style="width: 10%" class="text-info">{{ 'pages.decision.evaluation.correct' | translate }}</th>
        <th scope="col" style="width: 10%" class="text-danger">{{ 'pages.decision.evaluation.positive' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.positive_true' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.negative_true' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-info">{{ 'pages.decision.evaluation.true_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-info">{{ 'pages.decision.expectation.true_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-danger">{{ 'pages.decision.evaluation.false_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-danger">{{ 'pages.decision.expectation.false_positive' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let model of getEngineEvaluations()">
        <td>{{model.batch}}</td>
        <td>{{model.results?.total}}</td>
        <td class="text-info fw-bolder">{{model.results?.correct}}</td>
        <td class="text-danger fw-bolder">{{model.results?.positive}}</td>
        <td>{{model.results?.positiveTrue}}</td>
        <td>{{model.results?.negativeTrue}}</td>
        <td class="table-info">{{model.results?.getTruePositive()?.toFixed(3)}}</td>
        <td class="table-info">{{model.expectations?.truePositive?.mean?.toFixed(3)}}</td>
        <td class="table-danger">{{model.results?.getFalsePositive()?.toFixed(3)}}</td>
        <td class="table-danger">{{model.expectations?.falsePositive?.mean?.toFixed(3)}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table class="table table-light mb-0" style="font-size: 85%">
      <thead>
      <span>Decision Contour</span>
      <tr>
        <th scope="col" style="width: 10%">{{ 'pages.decision.model.batch' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.total' | translate }}</th>
        <th scope="col" style="width: 10%" class="text-info">{{ 'pages.decision.evaluation.correct' | translate }}</th>
        <th scope="col" style="width: 10%" class="text-danger">{{ 'pages.decision.evaluation.positive' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.positive_true' | translate }}</th>
        <th scope="col" style="width: 10%">{{ 'pages.decision.evaluation.negative_true' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-info">{{ 'pages.decision.evaluation.true_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-info">{{ 'pages.decision.expectation.true_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-danger">{{ 'pages.decision.evaluation.false_positive' | translate }}</th>
        <th scope="col" style="width: 10%" class="table-danger">{{ 'pages.decision.expectation.false_positive' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let model of getDecisionEvaluations()">
        <td>{{model.batch}}</td>
        <td>{{model.results?.total}}</td>
        <td class="text-info fw-bolder">{{model.results?.correct}}</td>
        <td class="text-danger fw-bolder">{{model.results?.positive}}</td>
        <td>{{model.results?.positiveTrue}}</td>
        <td>{{model.results?.negativeTrue}}</td>
        <td class="table-info">{{model.results?.getTruePositive()?.toFixed(3)}}</td>
        <td class="table-info">{{model.expectations?.truePositive?.mean?.toFixed(3)}}</td>
        <td class="table-danger">{{model.results?.getFalsePositive()?.toFixed(3)}}</td>
        <td class="table-danger">{{model.expectations?.falsePositive?.mean?.toFixed(3)}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
